export * as textStyleConfigs from './style-configs';
export { Text } from './text';
export type { TextProps, TextStyleConfig } from './types';
